import { render, staticRenderFns } from "./expertNotice.vue?vue&type=template&id=677b9546&scoped=true&"
import script from "./expertNotice.vue?vue&type=script&lang=js&"
export * from "./expertNotice.vue?vue&type=script&lang=js&"
import style0 from "./expertNotice.vue?vue&type=style&index=0&id=677b9546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677b9546",
  null
  
)

export default component.exports